<template>
  <div class="my">
    <div class="userInfo" v-loading="loading">
      <div class="infoLeft">
        <div class="leftTop">
          <div class="leftTop-avatar">
            <el-avatar
              v-if="userInfo.Icon"
              :size="60"
              :src="userInfo.Icon"
            ></el-avatar>
            <el-avatar v-else :size="60" icon="el-icon-user-solid"></el-avatar>

            <span class="userName"
              >{{ userInfo.PMC_Name }}<br /><span style="margin-left: 20px">{{
                userInfo.Person
              }}</span></span
            >
          </div>
          <div class="but">
            <el-button type="primary" @click="$router.go(-1)"
              >后退前页</el-button
            >
          </div>
        </div>
        <div class="leftBottom">
          <ul>
            <li
              style=""
              :class="menuActive == item.title ? 'active' : ''"
              v-for="item in menuList"
              :key="item.title"
              @click="menuClick(item)"
            >
              {{ item.title }}
              <el-badge
                v-if="item.title == '通知' && UnreadTotal > 0"
                :value="UnreadTotal"
                :max="99"
                class="item"
              ></el-badge>
            </li>
          </ul>
        </div>
      </div>
      <div class="infoRight">
        <div class="rightCard" v-show="menuActive == '用户信息'">
          <div class="cardHeader">{{ menuActive }}</div>
          <div class="cardContent">
            <el-form
              ref="form"
              :model="userInfo"
              label-width="120px"
              label-position="left"
            >
              <div
                class="formLable"
                style="
                  padding: 0 0 20px 0;
                  box-shadow: none;
                  align-items: center;
                "
              >
                <div
                  class="el-form-item__label"
                  style="width: 100px; text-align: left"
                >
                  头像
                </div>
                <el-avatar
                  v-if="userInfo.Icon"
                  :size="100"
                  :src="userInfo.Icon"
                ></el-avatar>
                <el-avatar
                  v-else
                  :size="100"
                  icon="el-icon-user-solid"
                ></el-avatar>
              </div>
              <el-form-item label="手机号/用户名">
                <el-input
                  v-model="userInfo.AccountName"
                  :maxlength="11"
                  type="text"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="公司名称">
                <el-input v-model="userInfo.PMC_Name" disabled></el-input>
              </el-form-item>
              <el-form-item label="联系人">
                <el-input v-model="userInfo.Person"></el-input>
              </el-form-item>
              <!-- <el-form-item label="邮箱">
                <el-input v-model="userInfo.Email"></el-input>
              </el-form-item> -->

              <el-form-item
                label="签名"
                style="height: 121px; position: relative"
              >
                <div
                  style="
                    width: 100%;
                    display: inline-block;
                    height: 120px;
                    border: 1px solid #ccc;
                    box-sizing: border-box;
                  "
                >
                  <el-image
                    style="width: 100%; height: 100%"
                    :src="userInfo.Sign"
                    fit="contain"
                    v-if="userInfo.Sign"
                  ></el-image>
                  <div
                    v-else
                    style="
                      width: 100%;
                      height: 100%;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      color: #c0c4cc;
                      background: #f5f7fa;
                    "
                  >
                    暂无签名
                  </div>
                </div>
                <el-button
                  style="
                    width: 100px;
                    position: absolute;
                    right: -115px;
                    top: 30px;
                  "
                  type="primary"
                  @click="openSignDialog"
                  >设置签名</el-button
                >
                <el-button
                  style="
                    width: 100px;
                    position: absolute;
                    right: -115px;
                    top: 80px;
                  "
                  type="primary"
                  @click="resetData"
                  >刷新</el-button
                >
              </el-form-item>
              <el-form-item>
                <el-button
                  size="mini"
                  type="primary"
                  @click="onSubmitUserInfo"
                  :loading="loading"
                  style="width: 100%"
                  >保存
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-show="menuActive == '修改密码'">
          <div class="rightCard"></div>
          <div class="rightCard">
            <div class="cardHeader">修改密码</div>
            <div class="cardContent">
              <el-form
                ref="form"
                :model="form"
                label-width="100px"
                label-position="right"
              >
                <el-form-item label="旧密码：">
                  <el-input v-model="form.oldPwd" show-password></el-input>
                </el-form-item>
                <el-form-item label="新密码：">
                  <el-input v-model="form.newPwd" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认新密码：">
                  <el-input v-model="form.confirmPwd" show-password></el-input>
                </el-form-item>
                <el-form-item class="lastBtn">
                  <el-button
                    :loading="loading"
                    size="mini"
                    type="primary"
                    style="width: 120px"
                    @click="onSubmit"
                    >保存
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="设置签名"
      :visible.sync="signQrcodeDialogVisible"
      width="300px"
    >
      <div
        style="
          color: red;
          font-weight: bold;
          font-size: 16px;
          text-align: center;
        "
      >
        请用手机扫描二维码设置签名
      </div>
      <div style="width: 100%; text-align: center">
        <vue-qr :size="200" :text="signQrcode"></vue-qr>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="signQrcodeDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const reg = /^1[345789]\d{9}$/ // 手机号正则
import TokenCache from '@/utils/cache/TokenCache'
import { mapState, mapActions } from 'vuex'

import vueQr from 'vue-qr'
export default {
  data() {
    return {
      signQrcode: '',
      signQrcodeDialogVisible: false,
      appid: 'wxef625270eda5492e',
      scope: 'snsapi_login',
      WXDialog: false,
      // 修改手机号弹窗
      centerDialogVisible: false,
      data: [],
      logining: false,
      sendAuthCode: true, //显示‘获取按钮'还是'倒计时'
      auth_time: 0 /*倒计时 计数器*/,
      verification: '', //绑定输入验证码框
      menuList: [
        {
          title: '用户信息',
        },
        {
          title: '修改密码',
        },
        // {
        //   title: "通知",
        // },
      ],
      menuActive: '用户信息',
      form: {},
      // 修改绑定手机号表单
      Form: {},
      loading: false,
      total: 0,
      UnreadTotal: '',
      TokenCache,
      userIcon: '',
      // 上传图片剪裁
      fileSrcList: [],
      showCropper: false, // 显示裁剪弹窗
      cropperOption: {
        // 裁剪配置
        img: '',
        autoCropWidth: 300,
        autoCropHeight: 300,
      },
      cropperStyle: {
        // 裁剪框大小
        width: '500px',
        height: '500px',
      },
      cropperData: {},
      userInfo: {},
      userInfoCopy: {},
    }
  },
  components: { vueQr },
  computed: {},
  mounted() {
    // 清空修改手机号表单数据
    this.Form = {}

    // this.userIcon = this.userInfo.Icon;
    this.menuActive = this.$route.query.type
      ? this.$route.query.type
      : '用户信息'
    this.getUserInfo()
  },
  methods: {
    async resetData() {
      await this.getUserInfo()
    },
    getUserInfo() {
      this.loading = true
      this.$http.post('/Base_Manage/Home/GetOperatorInfo').then((res) => {
        this.loading = false
        if (res.Success) {
          console.log('33333333333333333')
          this.userInfo = res.Data.UserInfo
          this.userInfoCopy = JSON.parse(JSON.stringify(this.userInfo))
          this.$store.commit('setUserInfo', res.Data.UserInfo)
          window.localStorage.setItem(
            'userInfo',
            JSON.stringify(res.Data.UserInfo)
          )
        }
      })
    },
    openSignDialog() {
      this.signQrcodeDialogVisible = true
      this.signQrcode =
        window.location.origin + '/UserSign?token=' + TokenCache.getToken()
    },

    // 获取用户信息
    op() {
      return this.$store.state.userInfo
    },

    beforeAvatarUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/jpg' ||
        file.type === 'image/png'
      const isLt20M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传头像图片只能是 JPG 或者 PNG 格式!')
      }
      if (!isLt20M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      // 校验通过后显示裁剪框
      this.canCropper = isJPG && isLt20M
      return false
    },
    handleSuccess(res, file) {
      if (res.Code == 200) {
        this.userIcon = res.Url
      }
    },
    menuClick(item) {
      this.menuActive = item.title
    },
    onSubmitUserInfo() {
      if (!this.userInfo.AccountName) {
        return this.$notify.error('请输入正确的手机号')
      }
      // 验证手机号格式
      if (this.userInfo.AccountName && !reg.test(this.userInfo.AccountName)) {
        this.$notify.error('请核对手机号格式')
        return
      }
      this.$confirm('确认保存当前用户信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.loading = true
        this.$http
          .post('/PB/PB_Project/SaveTransferRouteData', {
            UserName: this.userInfo.AccountName,
            RealName: this.userInfo.Person,
            TransferRoute: JSON.stringify(this.userInfo),
          })
          .then(async (res) => {
            this.loading = false
            if (res.Success) {
              if (this.userInfo.AccountName !== this.userInfoCopy.AccountName) {
                this.$notify.success('检测到已更换手机号，请重新登录')
                TokenCache.deleteToken()
                this.$store.commit('clearUserInfo')
                this.$router.replace('/')
                return
              }
              await this.getUserInfo()
              this.$notify.success('操作成功')
            } else this.$notify.error(res.Msg)
          })
      })
    },
    WXDialogbox() {
      this.WXDialog = true
    },
    // 更换绑定手机号
    handlerChangePhone() {
      this.centerDialogVisible = true
    },
    // 换绑手机提交
    handlerChangePhoneSubmit() {
      if (!this.Form.newPhone) return this.$notify.error('请输入手机号')
      if (!reg.test(this.Form.newPhone))
        return this.$notify.error('请核对手机号格式')
      if (!this.Form.code) return this.$notify.error('请输入验证码')
      console.log('更换绑定手机号', this.Form)
      // 关闭弹窗
      this.centerDialogVisible = false
      let oldPhone = JSON.parse(localStorage.getItem('userInfo')).Phone
      this.$http
        .post('Base_Manage/Home/UserReplacePhone', {
          Phone: oldPhone,
          SmsCode: this.Form.code,
          NewPhone: this.Form.newPhone,
        })
        .then((res) => {
          if (res.Success) {
            this.$notify.success('手机号变更成功,请重新登录')
            setTimeout(() => {
              TokenCache.deleteToken()
              this.$store.state.userInfo = {}

              this.$store.state.isLogin = false
              this.$router.replace('/Home')
            }, 1000)
          } else {
            this.$notify.error('res.Msg')
          }
        })
    },

    // 修改密码
    onSubmit() {
      var that = this
      console.log('打印form', this.form)
      if (!this.form.oldPwd) return this.$notify.error('请输入旧密码')
      if (this.form.oldPwd === this.form.newPwd)
        return this.$notify.error('新密码不能与旧密码相同')
      if (!this.form.newPwd) return this.$notify.error('请输入新密码')
      if (!this.form.confirmPwd) return this.$notify.error('请再次输入新密码')
      if (this.form.newPwd !== this.form.confirmPwd)
        return this.$notify.error('两次输入的密码不一致')
      console.log('可以走了')
      this.loading = true
      this.$http
        .post('/PB/PB_Project/SaveTransferRoutePasswordData', {
          TransferRoute: JSON.stringify({
            Id: this.userInfo.Id,
            Password: this.form.newPwd,
          }),
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.$notify.success('修改成功')
            setTimeout(function () {
              that.$message.warning('请使用新密码重新登录')
              TokenCache.deleteToken()
              that.$store.state.userInfo = {}
              that.$store.state.isLogin = false
              that.$router.replace('/')
            }, 1000)
          } else this.$notify.error(res.Msg)
        })
    },
    // 回调地址获取
    getRedirect_uri() {
      let protocolStr = document.location.protocol
      return encodeURIComponent(protocolStr + '//www.zytsaas.com/My/BindingWX')
    },

    read(item) {
      if (item.Status != 0) return
      this.$http
        .post(
          '/Base_Message/Base_InviteMessage/UpdateInviteMessageData?Id=' +
            item.Id
        )
        .then((res) => {
          if (res.Success) {
            item.Status = 1
            this.$notify({
              type: 'success',
              message: '操作成功',
            })
            this.getDataList()
          } else
            this.$notify({
              type: 'error',
              message: res.Msg,
            })
        })
    },
    // 上传图片剪裁
    handleCrop(file) {
      // 点击弹出剪裁框
      this.$nextTick(() => {
        if (this.canCropper) {
          this.cropperOption.img = window.URL.createObjectURL(file.raw)
          this.showCropper = this.canCropper
        }
      })
    },
    // 自定义上传方法
    async uploadImg(file, data) {
      let fileFormData = new FormData()
      fileFormData.append('file', file)
      fileFormData.append('type', 0)
      // 移除上传组件带来的bug
      // document.getElementsByTagName('body')[0].removeAttribute('style')
      this.cropperData.iconUrl = data
      this.showCropper = false
      //调用上传文件接口 以及回调
      const res = await this.$http.post(
        'Base_Manage/Upload/VipUserImgOssUploadFileByForm',
        fileFormData
      )
      if (res.Code != 200) {
        this.$notify.error(res.msg)
        return
      }
      this.userIcon = res.Url
      this.onSubmitUserInfo()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-input--prefix .el-input__inner {
  border-radius: 5px;
}

::v-deep .el-avatar img {
  display: block;
  height: 100%;
  width: 100%;
  vertical-align: middle;
}

.loginAndRegister {
  width: 100%;
  // min-height: 63vh;
  margin: 0 auto;

  .box1,
  .box2 {
    background-color: #ffffff;
    width: 100%;
    height: auto;
    margin: 0 auto;
    padding: 0 30px;
  }

  .box1 .el-form-item {
    margin-top: 20px;
  }

  .box1 .btn1 {
    font-size: 20px;
  }

  .box1 .el-form-item .imgs1 {
    width: 37px;
    margin-top: 11px;
    margin-left: -55%;
  }

  .box1 .Back {
    margin-left: 75%;
    color: #409eff;
    font-size: 20px;
    display: flex;
    margin-top: -14%;
    cursor: pointer;
  }

  .box1 .revise {
    margin-left: 79%;
    color: rgb(95, 170, 255);
    font-size: 20px;
    display: flex;
    margin-top: -11.5%;
    cursor: pointer;
  }
}

.reuse {
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 5px 0 rgb(57 66 60 / 20%);
  box-sizing: border-box;
}

.active {
  font-weight: bold;
  color: #000 !important;
}

.lastBtn {
  margin-bottom: 0;
}

::v-deep .el-form-item__label {
  font-size: 14px;
  color: gray;
  font-weight: bold;
}

::v-deep .infoRight {
  .el-form-item__content {
    width: 300px;
    height: 40px;
  }
}

.my {
  width: 100%;
  height: 100%;
  background: #ededed;
  overflow-y: auto;

  .register_box_right {
    .content {
      // width: 8.592593rem;
      // height: 70%;
      // margin: 30vh auto;
      .inputs {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
          margin-bottom: 21px;
        }
      }

      .auth_text {
        margin: -22px 0 0 10px;
      }

      .inputs.phone {
        .el-form-item {
          width: 100% !important;
        }
      }

      .content_text {
        font-size: 0.518519rem;
        font-weight: 600;
        color: #525252;
        line-height: 0.611111rem;
        margin-bottom: 0.8rem;
      }

      .button_obtain {
        cursor: pointer;
        margin: -22px 0 0 5px;
      }

      button {
        height: 37px;
        width: 25%;
        border: none;
        color: #ffffff;
        background: linear-gradient(223deg, #f74340 0%, #fc8e8b 100%);
        border-radius: 0.074074rem 0.074074rem 0.074074rem 0.074074rem;
        opacity: 1;
      }

      .register_button {
        width: 100%;
        border-radius: 0.111111rem 0.111111rem 0.111111rem 0.111111rem;
        opacity: 1;

        button {
          background: linear-gradient(223deg, #f74340 0%, #fc8e8b 100%);
          width: 100%;
          height: 100%;
          border: none;
          font-size: 0.296296rem;
          font-weight: 500;
          color: #ffffff;
          line-height: 0.351852rem;
        }
      }
    }
  }

  .navHeader {
    @extend .reuse;
    border-radius: 0;
    padding: 0 10px;
    height: 48px;
    line-height: 48px;
    display: flex;
    justify-content: space-between;
    color: #000;

    .logoLeft {
      font-weight: bold;
    }

    .userRight {
      display: flex;
      align-items: center;
      width: 90px;
      justify-content: space-between;
      padding: 0 20px;
      border-left: 1px solid rgba(0, 0, 0, 0.07);
      cursor: pointer;
    }
  }

  .userInfo {
    width: 1000px;
    margin: 0 auto;
    margin-top: 20px;
    box-sizing: border-box;
    padding: 0 20px;
    padding-bottom: 20px;
    display: flex;

    .infoLeft {
      box-sizing: border-box;
      width: 320px;
      padding: 0 10px;

      .leftTop {
        @extend .reuse;

        padding: 20px;
        font-size: 18px;
        font-weight: bold;

        .leftTop-avatar {
          display: flex;
          align-items: center;
        }
        .but {
          margin-top: 10px;
          width: 100%;
          .el-button {
            width: 100%;
          }
        }
        .userName {
          margin-left: 20px;
          flex: 1;
        }
      }

      .leftBottom {
        @extend .reuse;
        margin-top: 10px;

        ul {
          cursor: pointer;

          li {
            padding: 15px 20px;
            font-size: 18px;
            color: grey;
            box-shadow: 0 1px 0 rgb(0 0 0 / 5%);
            display: flex;
            justify-content: space-between;

            &:hover {
              background: #f1f1f1;
              font-weight: bold;
            }
          }
        }
      }
    }

    .infoRight {
      flex: 1;
      padding: 0 10px;

      .rightCard {
        @extend .reuse;

        .content {
          height: 85vh;
          overflow-y: auto;
          padding: 15px;
          margin-top: 20px;
        }

        .content .box {
          border: 1px solid #d3d3d3;
          border-radius: 10px;
          padding: 10px;
          margin-top: 10px;
          display: flex;
          align-items: center;

          .tagbox {
            text-align: right;
          }
        }

        .cardHeader {
          padding: 20px 20px 0;
          font-size: 18px !important;
          @extend .active;
        }

        .cardTip {
          color: gray;
          padding: 20px;
          padding-top: 6px;
          font-size: 14px;
          margin: 0;
          box-shadow: 0 1px 0 rgb(0 0 0 / 10%);
        }

        .formLable {
          display: flex;
          padding: 20px;
          // box-shadow: 0 1px 0 rgb(0 0 0 / 10%);
        }

        .cardContent {
          padding: 20px;
        }
      }
    }
  }
}
</style>
